import { faLink, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import type { NavigateFunction } from "react-router-dom";
import type { IPagedListAction } from "../../components/UI/Declarations";
import {
    buildLocationAdminPagedListActions,
    type LocationAdminConfirmKind,
} from "../LocationsListPage/locationAdminListActions";

export type LocationEditActiveView = "edit" | "associations";

export function buildLocationEditHeaderActions(
    navigate: NavigateFunction,
    locationId: string,
    openConfirm: (kind: LocationAdminConfirmKind) => void,
    activeView: LocationEditActiveView
): IPagedListAction[] {
    const navigationAction: IPagedListAction =
        activeView === "edit"
            ? {
                  text: "View Associations",
                  icon: faLink,
                  onClick: () => navigate(`/locations/${locationId}/associations`),
              }
            : {
                  text: "Edit Location",
                  icon: faPenToSquare,
                  onClick: () => navigate(`/locations/${locationId}`),
              };

    const lifecycleActions = buildLocationAdminPagedListActions(openConfirm);
    if (lifecycleActions.length > 0) {
        lifecycleActions[0] = { ...lifecycleActions[0], startGroup: true };
    }

    return [navigationAction, ...lifecycleActions];
}
